import { IWheelTires } from "api/interfaces/static-pages/wheels-tires.type";
import Index from "./wheels-tires/WheelsTires";

function WheelsTires(props: IWheelTires) {
  return <Index {...props} />;
}

export default WheelsTires;
